import React from "react"
import {RefTable, DefaultProps, Validator, Visibility} from "../RefTable"

export const InvoicingFees = (props)=><RefTable {...props}/>;

InvoicingFees.defaultProps = {
    ...DefaultProps,
    title: "Invoicing Fees",
    tableSchema: "em_invoicing_fee_type",
    tableName: "em_invoicing_fee_type",
    edit: true,
    validator: {
        fee_value: new Validator("fee_value", async (value)=> {
            if(value < 0 )
                return Promise.reject("Invoicing fee cannot be negative")
        })
    },
    formVisibility:{
        currency: new Visibility("currency", ()=>false)
    }
}
